<template>
  <div class="menu-box">
    <div class="logo-box fx fxCc">
      <img class="logo" src="@/assets/image/logo.png" alt="" srcset="" />
      <div class="title">汽车试验系统</div>
    </div>
    <div class="menu-item fx aic" :class="{ menuItemActive: menuId == item.id }" v-for="(item, index) in menuData"
      :key="index" @click="handleMenu(item)">
      <img class="menu-icon" :src="menuId == item.id ? item.iconActive : item.icon" />
      <div class="menu-title" :class="{ menuTitleActive: menuId == item.id }">
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuId: 1,
      menuData: [
        {
          id: 1,
          title: "数据统计",
          icon: require("@/assets/image/meun/statistics.png"),
          iconActive: require("@/assets/image/meun/statistics-active.png"),
          url: "/dataStatistics/statistics",
        },
        {
          id: 2,
          title: "车辆管理",
          icon: require("@/assets/image/meun/car.png"),
          iconActive: require("@/assets/image/meun/car-active.png"),
          url: "/carManagement/carList",
        },
        {
          id: 3,
          title: "试验员管理",
          icon: require("@/assets/image/meun/people.png"),
          iconActive: require("@/assets/image/meun/people-active.png"),
          url: "/testerManagement/testerList",
        },
        {
          id: 4,
          title: "试验任务",
          icon: require("@/assets/image/meun/task.png"),
          iconActive: require("@/assets/image/meun/task-active.png"),
          url: "/testTaskManagement/testTaskList",
        },
        {
          id: 5,
          title: "角色管理",
          icon: require("@/assets/image/meun/set.png"),
          iconActive: require("@/assets/image/meun/set-active.png"),
          url: "/systemManagement/roleList",
        },
        {
          id: 6,
          title: "用户管理",
          icon: require("@/assets/image/meun/set.png"),
          iconActive: require("@/assets/image/meun/set-active.png"),
          url: "/systemManagement/userList",
        },
      ],
    };
  },
  methods: {
    handleMenu(item) {
      this.menuId = item.id
      this.$router.push(item.url);
    }
  },
  components: {},
};
</script>

<style scoped lang="less">
.menu-box {
  min-height: 100vh;
  padding: 20px;
  background-image: url('../assets/image/meun/bg.png');
  background-size: 100% 100%;

  background-repeat: no-repeat;

  .logo-box {
    .logo {
      width: 32px;
      height: 32px;
    }

    .title {
      margin-left: 16px;
      font-weight: bold;
      font-size: 20px;
      color: #1d2129;
    }
  }

  .menu-item {
    cursor: pointer;
    padding: 15px;
    margin-top: 20px;

    .menu-icon {
      width: 18px;
      height: 18px;
    }

    .menu-title {
      margin-left: 16px;
      font-weight: 500;
      font-size: 14px;
      color: #4e5969;
    }

    .menuTitleActive {
      color: #fff;
    }
  }

  .menuItemActive {
    background: #165dff;
    box-shadow: 0px 4px 8px 0px rgba(22, 93, 255, 0.25);
    border-radius: 4px;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }
}
</style>
